import {
    formatOneDigitNumber,
    formatTwoOrThreeDecimals,
    getWeightedAverageBy,
    plainAverage,
    weightAverageByMileage,
} from '@utils/formatters';


import createColumn from './createColumn';

export const consumptionPerTimeSignal = {
    format: formatOneDigitNumber,
    average: (values: number[]) => getWeightedAverageBy(values),
};

export const electricConsumptionPerTimeSignal = {
    format: formatOneDigitNumber,
    average: (values: number[]) => getWeightedAverageBy(values),
};

export const distancePerConsumptionSignal = {
    format: formatOneDigitNumber,
    average: weightAverageByMileage,
};

export const distancePerElectricConsumptionSignal = {
    format: formatOneDigitNumber,
    average: weightAverageByMileage,
};

export const fuelEfficiencySignal = {
    format: formatOneDigitNumber,
    average: plainAverage,
};

export const consumptionSignal = {
    rawFormat: formatOneDigitNumber,
    format: formatOneDigitNumber,
    average: plainAverage,
    unit: 'fuelConsumption',
};

export const electricConsumptionSignal = {
    rawFormat: formatOneDigitNumber,
    format: formatOneDigitNumber,
    average: plainAverage,
    unit: 'electricOperatingConsumption',
};

export const consumptionPerDistanceSignal = {
    format: formatOneDigitNumber,
    average: weightAverageByMileage,
};

export const electricConsumptionPerDistanceSignal = {
    format: formatTwoOrThreeDecimals,
    average: weightAverageByMileage,
};

export const fuelConsumption = createColumn({
    key: 'fuelConsumption',
    dataField: 'fuelConsumption',
    labelId: 'fuelConsumption',
    formatter: consumptionSignal.format,
});

export const electricOperatingConsumption = createColumn({
    key: 'electricOperatingConsumption',
    dataField: 'electricOperatingConsumption',
    labelId: 'fuelConsumption',
    formatter: electricConsumptionSignal.format,
});

export const cruiseControlConsumptionInPotential = createColumn({
    key: 'cruiseControlConsumptionInPotential',
    dataField: 'cruiseControlConsumptionInPotential',
    labelId: 'cruiseControlConsumptionInPotential',
    formatter: consumptionPerDistanceSignal.format,
});

export const electricCruiseControlConsumptionInPotential = createColumn({
    key: 'electricCruiseControlConsumptionInPotential',
    dataField: 'cruiseControlConsumptionInPotential',
    labelId: 'electricCruiseControlConsumptionInPotential',
    formatter: electricConsumptionPerDistanceSignal.format,
});

export const noCruiseControlConsumptionInPotential = createColumn({
    key: 'noCruiseControlConsumptionInPotential',
    dataField: 'noCruiseControlConsumptionInPotential',
    labelId: 'noCruiseControlConsumptionInPotential',
    formatter: consumptionPerDistanceSignal.format,
});

export const electricNoCruiseControlConsumptionInPotential = createColumn({
    key: 'electricNoCruiseControlConsumptionInPotential',
    dataField: 'noCruiseControlConsumptionInPotential',
    labelId: 'electricNoCruiseControlConsumptionInPotential',
    formatter: electricConsumptionPerDistanceSignal.format,
});

export const operatingFuelConsumption = createColumn({
    key: 'operatingFuelConsumption',
    dataField: 'operatingFuelConsumption',
    labelId: 'operatingFuelConsumption',
    formatter: consumptionPerDistanceSignal.format,
});

export const electricAverageOperatingConsumption = createColumn({
    key: 'electricAverageOperatingConsumption',
    dataField: 'electricAverageOperatingConsumption',
    labelId: 'operatingFuelConsumption',
    formatter: electricConsumptionPerDistanceSignal.format,
});

export const drivingConsumption = createColumn({
    key: 'drivingConsumption',
    dataField: 'drivingConsumption',
    labelId: 'drivingConsumption',
    formatter: consumptionPerDistanceSignal.format,
});

export const electricAverageDrivingConsumption = createColumn({
    key: 'electricAverageDrivingConsumption',
    dataField: 'electricAverageDrivingConsumption',
    labelId: 'drivingConsumption',
    formatter: electricConsumptionPerDistanceSignal.format,
});

export const distanceFuelConsumption = createColumn({
    key: 'distanceFuelConsumption',
    dataField: 'distanceFuelConsumption',
    labelId: 'distanceFuelConsumption',
    formatter: distancePerConsumptionSignal.format,
});

export const electricAverageOperatingConsumptionRange = createColumn({
    key: 'electricAverageOperatingConsumptionRange',
    dataField: 'electricAverageOperatingConsumptionRange',
    labelId: 'distanceFuelConsumption',
    formatter: distancePerElectricConsumptionSignal.format,
});

export const idlingConsumption = createColumn({
    key: 'idlingConsumption',
    dataField: 'idlingConsumption',
    labelId: 'idlingConsumption',
    formatter: consumptionPerTimeSignal.format,
});

export const electricAverageIdlingConsumption = createColumn({
    key: 'electricAverageIdlingConsumption',
    dataField: 'electricAverageIdlingConsumption',
    labelId: 'electricAverageIdlingConsumption',
    formatter: electricConsumptionPerTimeSignal.format,
});

export const fuelAndElectricAverageIdlingConsumption = createColumn({
    key: 'electricAverageIdlingConsumption',
    dataField: 'electricAverageIdlingConsumption',
    labelId: 'fuelAndElectricAverageIdlingConsumption',
    formatter: electricConsumptionPerTimeSignal.format,
});

export const fuelEfficiency = createColumn({
    key: 'fuelEfficiency',
    dataField: 'fuelEfficiency',
    labelId: 'fuelEfficiency',
    formatter: fuelEfficiencySignal.format,
});

export const electricEfficiency = createColumn({
    key: 'electricEfficiency',
    dataField: 'electricEfficiency',
    labelId: 'energyEfficiency',
    formatter: formatTwoOrThreeDecimals,
});

export const electricRecuperation = createColumn({
    key: 'electricRecuperation',
    dataField: 'electricRecuperation',
    labelId: 'electricRecuperation',
    formatter: formatOneDigitNumber,
});

export const DrivetrainConsumption = createColumn({
    key: 'drivetrainConsumption',
    dataField: 'drivetrainConsumption',
    labelId: 'drivetrainConsumption',
    formatter: formatOneDigitNumber,
});

export const EptoConsumption = createColumn({
    key: 'eptoConsumption',
    dataField: 'eptoConsumption',
    labelId: 'eptoConsumption',
    formatter: formatOneDigitNumber,
});

export const BatterylossesConsumption = createColumn({
    key: 'batterylossesConsumption',
    dataField: 'batterylossesConsumption',
    labelId: 'batterylossesConsumption',
    formatter: formatOneDigitNumber,
});

export const AircompressorConsumption = createColumn({
    key: 'aircompressorConsumption',
    dataField: 'aircompressorConsumption',
    labelId: 'aircompressorConsumption',
    formatter: formatOneDigitNumber,
});

export const CoolingConsumption = createColumn({
    key: 'coolingConsumption',
    dataField: 'coolingConsumption',
    labelId: 'coolingConsumption',
    formatter: formatOneDigitNumber,
});

export const HvacConsumption = createColumn({
    key: 'hvacConsumption',
    dataField: 'hvacConsumption',
    labelId: 'hvacConsumption',
    formatter: formatOneDigitNumber,
});

export const VpowersupplyConsumption = createColumn({
    key: 'vpowersupplyConsumption',
    dataField: 'vpowersupplyConsumption',
    labelId: 'vpowersupplyConsumption',
    formatter: formatOneDigitNumber,
});

export const TotalConsumption = createColumn({
    key: 'totalPowerConsumption',
    dataField: 'totalPowerConsumption',
    labelId: 'totalPowerConsumption',
    formatter: formatOneDigitNumber,
});

export const electricRecuperationPerKm = createColumn({
    key: 'electricRecuperationPerKm',
    dataField: 'electricRecuperationPerKm',
    labelId: 'electricRecuperationPerKm',
    formatter: formatOneDigitNumber,
});

export const DrivetrainPerKm = createColumn({
    key: 'drivetrainConsumptionPerKm',
    dataField: 'drivetrainConsumptionPerKm',
    labelId: 'drivetrainConsumptionPerKm',
    formatter: formatOneDigitNumber,
});

export const EptoPerKm = createColumn({
    key: 'eptoConsumptionPerKm',
    dataField: 'eptoConsumptionPerKm',
    labelId: 'eptoConsumptionPerKm',
    formatter: formatOneDigitNumber,
});

export const BatterylossesPerKm = createColumn({
    key: 'batterylossesConsumptionPerKm',
    dataField: 'batterylossesConsumptionPerKm',
    labelId: 'batterylossesConsumptionPerKm',
    formatter: formatOneDigitNumber,
});

export const AircompressorPerKm = createColumn({
    key: 'aircompressorConsumptionPerKm',
    dataField: 'aircompressorConsumptionPerKm',
    labelId: 'aircompressorConsumptionPerKm',
    formatter: formatOneDigitNumber,
});

export const CoolingPerKm = createColumn({
    key: 'coolingConsumptionPerKm',
    dataField: 'coolingConsumptionPerKm',
    labelId: 'coolingConsumptionPerKm',
    formatter: formatOneDigitNumber,
});

export const HvacPerKm = createColumn({
    key: 'hvacConsumptionPerKm',
    dataField: 'hvacConsumptionPerKm',
    labelId: 'hvacConsumptionPerKm',
    formatter: formatOneDigitNumber,
});

export const VpowersupplyPerKm = createColumn({
    key: 'vpowersupplyConsumptionPerKm',
    dataField: 'vpowersupplyConsumptionPerKm',
    labelId: 'vpowersupplyConsumptionPerKm',
    formatter: formatOneDigitNumber,
});

export const electricEfficiencyPerKm = createColumn({
    key: 'electricEfficiency',
    dataField: 'electricEfficiency',
    labelId: 'energyEfficiency',
    formatter: formatOneDigitNumber,
});

export const electricRecuperationKmPerKwh = createColumn({
    key: 'electricRecuperationKmPerKwh',
    dataField: 'electricRecuperationKmPerKwh',
    labelId: 'electricRecuperationKmPerKwh',
    formatter: formatOneDigitNumber,
});

export const electricRecuperationPerHour = createColumn({
    key: 'electricRecuperationPerHour',
    dataField: 'electricRecuperationPerHour',
    labelId: 'electricRecuperationPerHour',
    formatter: formatOneDigitNumber,
});
